import { getEmpowerSaga, getEmpowerDetailsSaga } from './getEmpowerSaga'
import { getHomepageNewsSaga, getNewsSaga, getFeatureNewsSaga, getTagsSaga, getNewsDetailsSaga } from './getNewsSaga'
import { postContactSaga, postEmailSaga, snackbarLCGSaga, getBannerSaga } from './otherSaga'
import EmpowerActions from 'stores/leadbest-official-website/empower/actions';
import NewsActions from 'stores/leadbest-official-website/news/actions';
import OtherActions from 'stores/leadbest-official-website/other/actions';
import { takeLatest } from 'redux-saga/effects'

export default [
    takeLatest(EmpowerActions.GET_EMPOWER_REQUEST, getEmpowerSaga),
    takeLatest(EmpowerActions.GET_EMPOWERDETAILS_REQUEST, getEmpowerDetailsSaga),
    takeLatest(NewsActions.GET_HOMEPAGENEWS_REQUEST, getHomepageNewsSaga),
    takeLatest(NewsActions.GET_NEWS_REQUEST, getNewsSaga),
    takeLatest(NewsActions.GET_FEATURENEWS_REQUEST, getFeatureNewsSaga),
    takeLatest(NewsActions.GET_TAGS_REQUEST, getTagsSaga),
    takeLatest(NewsActions.GET_NEWSDETAILS_REQUEST, getNewsDetailsSaga),
    takeLatest(OtherActions.POST_CONTACT_REQUEST, postContactSaga),
    takeLatest(OtherActions.POST_EMAIL_REQUEST, postEmailSaga),
    takeLatest(OtherActions.SNACKBARLCG_REQUEST, snackbarLCGSaga),
    takeLatest(OtherActions.GET_BANNER_REQUEST, getBannerSaga),
]